export default "__VITE_ASSET__BwYZLCVz__"